/**
 * ⚠️ WARNING: DO NOT MODIFY THIS FILE DIRECTLY ⚠️
 *
 * This file is auto-generated from roles/roles.yaml
 * To make changes to roles or role-related functionality:
 * 1. Edit roles/roles.yaml
 * 2. Run 'yarn generate:roles'
 *
 * Any direct modifications to this file will be overwritten.
 */
export const ROLES = {
    ORGANIZATION_ADMIN: 'organization_admin',
    PRO_APPROVER: 'pro_approver',
    PRO_RESTRICTED: 'pro_restricted',
    PRO_USER: 'pro_user',
    PULSE_USER: 'pulse_user',
    SYSTEM_ADMIN: 'system_admin',
    DEVELOPER: 'developer',
    NAVIGATION_USER: 'navigation_user',
    PERSONA_SHARING_USER: 'persona_sharing_user',
    DOWNLOAD_POWERPOINT_USER: 'download_powerpoint_user',
    AGENT_INTAKE_USER: 'agent_intake_user',
    SEARCH_USER: 'search_user',
    PULSE3_MVP_USER: 'pulse3_mvp_user',
    PULSE_UPLOAD_PROXY_USER: 'pulse_upload_proxy_user',
};
export const ROLE_DEFINITIONS = {
    organization_admin: {
        description: 'Administrator role with full access to the logged in organization',
        user_facing: true,
        manage_assignable: true,
        legacy_terraform: true,
    },
    pro_approver: {
        description: 'Elevated PRO user with access to the logged in organization, and the ability to approve submitted studies',
        user_facing: true,
        manage_assignable: true,
        legacy_terraform: true,
    },
    pro_restricted: {
        description: 'Restricted PRO user with basic access to the logged in organization, and the ability to submit studies for approval',
        user_facing: true,
        manage_assignable: true,
        legacy_terraform: true,
    },
    pro_user: {
        description: 'Standard PRO user with basic access to the logged in organization',
        user_facing: true,
        manage_assignable: true,
        legacy_terraform: true,
    },
    pulse_user: {
        description: 'Standard Pulse user with basic access to the logged in organization',
        user_facing: true,
        manage_assignable: true,
        legacy_terraform: true,
    },
    system_admin: {
        description: 'Super administrator with cross-organization access (can manage all organizations, limited to WEVO employees)',
        user_facing: false,
        manage_assignable: false,
        legacy_terraform: true,
    },
    developer: {
        description: 'Use with access to development tools and resources',
        user_facing: false,
        manage_assignable: false,
        legacy_terraform: true,
    },
    navigation_user: {
        description: 'Agent Navigation in the Customer application and Pulse API',
        user_facing: true,
        manage_assignable: true,
        legacy_terraform: false,
    },
    persona_sharing_user: {
        description: 'Persona sharing in the Customer application and Pulse API',
        user_facing: true,
        manage_assignable: true,
        legacy_terraform: false,
    },
    download_powerpoint_user: {
        description: 'PowerPoint presentation downloads in the Customer application and Pulse API',
        user_facing: true,
        manage_assignable: true,
        legacy_terraform: false,
    },
    agent_intake_user: {
        description: 'Conversational Agent Intake setup in the Pulse API',
        user_facing: true,
        manage_assignable: true,
        legacy_terraform: false,
    },
    search_user: {
        description: 'Global Pulse search in the Customer application and Pulse API',
        user_facing: true,
        manage_assignable: true,
        legacy_terraform: false,
    },
    pulse3_mvp_user: {
        description: 'Pulse 3.0 release bundle (features staged before they reach pulse_user) for WEVO employees and selected customers',
        user_facing: true,
        manage_assignable: true,
        legacy_terraform: false,
    },
    pulse_upload_proxy_user: {
        description: 'Routes Pulse file uploads through the Customer API host for networks that only allow allowlisted upload hosts',
        user_facing: true,
        manage_assignable: true,
        legacy_terraform: false,
    },
};
/**
 * Type guard to check if a string is a valid role
 */
export const isValidRole = (role) => {
    return Object.values(ROLES).includes(role);
};
/**
 * Roles WEVO admins may assign and remove per organization from Manage
 */
export const MANAGE_ASSIGNABLE_ROLES = [
    'organization_admin',
    'pro_approver',
    'pro_restricted',
    'pro_user',
    'pulse_user',
    'navigation_user',
    'persona_sharing_user',
    'download_powerpoint_user',
    'agent_intake_user',
    'search_user',
    'pulse3_mvp_user',
    'pulse_upload_proxy_user',
];
/**
 * Type guard to check if a role may be assigned or removed from Manage
 */
export const isManageAssignableRole = (role) => {
    return MANAGE_ASSIGNABLE_ROLES.includes(role);
};
//# sourceMappingURL=roles.js.map